module.exports = {"api":{"baseUrl":"https://dev.ptparse.contractwella.com.es","appId":"app"},"server":{"port":1360}}


//////////////////
// WEBPACK FOOTER
// ./src/config/env.json
// module id = 1/LL
// module chunks = 1